import React from 'react';

import HtmlPreviewBox from '@dashboard/components/preview-boxes/HtmlPreviewBox';
import { useEmailMessageQuery } from '@dashboard/generated/wp/platform';
import { Box } from '@mui/material';

import RenderAttachments from './RenderAttachments';
import RenderError from './RenderError';

type Props = {
  waypointEventId: string;
};
export default function Preview({ waypointEventId }: Props) {
  const { loading, data } = useEmailMessageQuery({ variables: { id: waypointEventId } });

  const value = data?.EmailMessage.message.bodyHtml ?? undefined;
  return (
    <>
      <Box height={640}>
        <RenderError waypointEventId={waypointEventId} />
        <HtmlPreviewBox loading={loading} value={value} />
      </Box>
      <RenderAttachments waypointEventId={waypointEventId} />
    </>
  );
}
